import { auth } from "services/firebase";
async function request(path, options = {}) {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  const response = await fetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await auth.currentUser.getIdToken()}`,
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível consultar a produção.");
  return body;
}
export const getProductionOrders = (page, search, filters = {}) =>
  request(`/api/admin/production?${new URLSearchParams({ page, search, ...filters })}`);
export const updateProduction = (orderId, code, update) =>
  request(`/api/admin/production/${encodeURIComponent(orderId)}/${encodeURIComponent(code)}`, {
    method: "PUT",
    body: JSON.stringify(update),
  });
